import script from "./Calendario.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendario.vue?vue&type=script&setup=true&lang=js"

import "./Calendario.vue?vue&type=style&index=0&id=26e07ea7&scoped=true&lang=css"
import "./Calendario.vue?vue&type=style&index=1&id=26e07ea7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e07ea7"]])

export default __exports__